<aside
  class="aside"
  #nav
  ClickOutside
  (clickOutside)="sidebar.close()"
  [ngClass]="{
    open: sidebar.isOpen(),
  }"
>
  <!--SIDEBAR HEADER-->
  <div class="aside__header">
    <i class="close icon-close" (click)="sidebar.close()"></i>
    <a *appShellRenderSSR [href]="seo.originalLocationUrl() + '/' + lang.currentRouteLanguage">
      <img class="logo" loading="lazy" src="/assets/img/logo.png" alt="" />
    </a>
    @if (halloween.store().page && !halloween.store().page.isDisablePromo) {
      <div *appShellNoSSR class="cursor-pointer mt-12"
           (click)="sidebar.close()"
           [routerLink]="['/' + lang.currentRouteLanguage]">
        <app-lottie
          [width]="'180px'"
          [loop]="true"
          [animationSpeed]="0.85"
          [path]="'/assets/lottie/jsons/halloween/ghost-logo.json'"
          [assetsPath]="'/assets/lottie/images/halloween/ghost-logo/'">
        </app-lottie>
      </div>
    }
    @if (xmas.store.page && !xmas.store.page.isDisablePromo) {
      <a [routerLink]="['/' + lang.currentRouteLanguage]" (click)="sidebar.close()">
        <img  class="logo xmas" loading="lazy" src="/assets/img/promo/xmas/logo.png" alt="" />
      </a>
    } @else {
      <a [routerLink]="['/' + lang.currentRouteLanguage]" (click)="sidebar.close()">
        <img  class="logo" loading="lazy" src="/assets/img/logo.png" alt="" />
      </a>
    }
  </div>
  <!--END SIDEBAR HEADER-->

  <!-- BALANCE -->
  @if (user.auth) {
    <div class="side-link">
      <img class="side-link__icon balance-image" loading="lazy" [src]="'/assets/img/new-categories/balance.png'" alt="" />
      <div class="balance-text">
        <span>{{ 't.balance' | translate }}:</span>
        <span class="side-link__label balance">
          {{ user.currentCurrency?.symbol || user.currentCurrency?.currency }}
          {{ user.currentCurrency?.amount | currencyFormat: user.currentCurrency?.currency }}
        </span>
      </div>
    </div>
  }
  <!-- END BALANCE -->

  <div class="aside__content">
    @if (user.auth) {
      <div class="account-buttons">
        <button
          class="btn btn--primary big btn--deposit"
          [routerLink]="motivateWithdrawal.isMotivateWithdrawalAvailable ? '/profile/cashout' : '/profile/deposit'"
          (click)="onDepositClick(!motivateWithdrawal.isMotivateWithdrawalAvailable)"
        >
          {{ (motivateWithdrawal.isMotivateWithdrawalAvailable ? 'btn.cashout' : 'btn.deposit') | translate }}
        </button>
      </div>
    }

    <!--ACCOUNT BUTTONS-->
    @if (!user.auth) {
      <div class="account-buttons">
        @if (user.isUserAlreadyRegistered() || restrictSignUp.isSignupRestricted()) {
          <button class="btn btn--primary big" routerLink="./" [queryParams]="{ modal: 'login' }" (click)="onLoginClick()">
            {{ 'btn.login' | translate }}
          </button>
        } @else {
          <button class="btn btn--primary big" routerLink="./" [queryParams]="{ modal: 'registration' }" (click)="onRegisterClick()">
            {{ 'btn.signup' | translate }}
          </button>
          <button class="btn btn--simple-primary big" routerLink="./" [queryParams]="{ modal: 'login' }" (click)="onLoginClick()">
            {{ 'btn.login' | translate }}
          </button>
        }
      </div>
    }
    <!--END ACCOUNT BUTTONS-->

    <!--PRIMARY MENU-->
    <div class="primary-links">
      @if (halloween.store().page && !halloween.store().page.isDisablePromo && !ar.isAr()) {
        <a
          class="side-link side-link--promo-menu xmas"
          [routerLink]="['/' + lang.currentRouteLanguage, 'promo', 'halloween']"
          (click)="this.sidebar.close()"
        >
          <div *appShellNoSSR class="cursor-pointer mt--32">
            <app-lottie
              [routerLink]="['/' + lang.currentRouteLanguage]"
              [width]="'70px'"
              [loop]="true"
              [animationSpeed]="0.85"
              [path]="'/assets/lottie/jsons/halloween/side-menu.json'">
            </app-lottie>
          </div>
          <div class="side-link__label">{{ 't.halloween-link' | translate }}</div>
        </a>
      }
      @if (xmas.store.page && !xmas.store.page.isDisablePromo && !ar.isAr()) {
        <a
          class="side-link side-link--promo-menu xmas"
          [routerLink]="['/' + lang.currentRouteLanguage, 'promo', 'xmas']"
          (click)="this.sidebar.close()"
        >
          <img loading="lazy" class="side-link__icon" loading="lazy" src="/assets/img/promo/xmas/promo-logo.png" />
          <div class="side-link__label">{{ 't.xmas' | translate }}</div>
        </a>
      }

      <a class="side-link" [routerLink]="['/' + lang.currentRouteLanguage, 'crypto-spin']" (click)="this.sidebar.close()">
        <img loading="lazy" class="side-link__icon" loading="lazy" [src]="'/assets/img/crypto-spin/logo.png'" />
        <span class="side-link__label">{{ 't.bonus-wheel' | translate }}</span>
      </a>

      @if (user.auth) {
        <a class="side-link" [routerLink]="['/' + lang.currentRouteLanguage, 'profile', 'account']" href="/profile/account" (click)="$event.preventDefault(); onAccountClick()">
          <img  class="side-link__icon" loading="lazy" [src]="'/assets/img/new-categories/account.png'" />
          <span class="side-link__label">{{ 'link.account' | translate }}</span>
        </a>
      }

      @if (user.auth) {
        <a class="side-link"  [routerLink]="['/', lang.currentRouteLanguage, 'missions']" (click)="onMissionsClick()">
          <img loading="lazy" class="side-link__icon" [src]="'/assets/img/missions/logo.png'" />
          <span class="side-link__label">{{ 'link.missions' | translate }}</span>
        </a>
      }

      @if (!user.auth) {
        <a class="side-link" href="/profile/account" (click)="$event.preventDefault(); onAccountClick()">
          <img class="side-link__icon" loading="lazy" [src]="'/assets/img/new-categories/account.png'" />
          <span class="side-link__label">{{ 'link.account' | translate }}</span>
        </a>
      }

      <a class="side-link" [routerLink]="['/' + lang.currentRouteLanguage, 'bonuses']" (click)="onBonusesClick()">
        <img class="side-link__icon" loading="lazy" [src]="'/assets/img/new-categories/offers.png'" />
        <span class="side-link__label">
          {{ 'link.bonuses' | translate }}
        </span>
      </a>

      <a class="side-link" [routerLink]="['/' + lang.currentRouteLanguage, 'vip-program']" (click)="sidebar.close()">
        <img class="side-link__icon" loading="lazy" [src]="'/assets/img/vip/icon.png'" />
        <span class="side-link__label">
          {{ 'link.vip' | translate }}
        </span>
      </a>

      @if (bonusStoreService.bonusStorePage$ | async) {
        <a class="side-link" [routerLink]="['/' + lang.currentRouteLanguage, 'bonus-shop']" (click)="sidebar.close()">
          <img class="side-link__icon" loading="lazy" [src]="'/assets/img/shop/side-icon.png'" />
          <span class="side-link__label">
          {{ 'link.bonus-shop' | translate }}
        </span>
        </a>
      }

      <a class="side-link" [routerLink]="['/' + lang.currentRouteLanguage, 'loyalty-program']" (click)="sidebar.close()">
        <img class="side-link__icon" loading="lazy" [src]="'/assets/img/new-categories/loyalty.png'" />
        <span class="side-link__label">{{ 'link.loyalty-program' | translate }}</span>
      </a>

      <a class="side-link" [routerLink]="['/' + lang.currentRouteLanguage, 'games']" (click)="sidebar.close(); sidebar.setisOpenedCasinoTodayInCookie()">
        <img class="side-link__icon" loading="lazy" [src]="'/assets/img/new-categories/games.png'" />
        <span class="side-link__label">
          {{ 'link.casino' | translate }}
          @if (!sidebar.isOpenedCasinoToday() && badge?.gameBadge()) {
            <img class="side-link__badge" [src]="ar?.isAr() ? '/assets/img/categories/notif-ar.png' : '/assets/img/categories/notif.png'" />
          }
        </span>
      </a>

      @if (zendesk.available()) {
        <a class="side-link" href="" (click)="$event.preventDefault(); zendeskLiveChatClick()">
          <img class="side-link__icon" loading="lazy" [src]="'/assets/img/new-categories/help-chat.png'" />
          <span class="side-link__label">
            {{ 'link.help' | translate }}
          </span>
        </a>
      }

      @if (installApp.isEnableNativeApp()) {
        <a class="side-link" (click)="installAppClick()" [routerLink]="['/' + lang.currentRouteLanguage, 'mobile-app']">
          <img class="side-link__icon" loading="lazy" [src]="'/assets/img/new-categories/pwa.png'" />
          <span class="side-link__label">{{ 'link.instal-app' | translate }}</span>
        </a>
      }

      <div>
        <span #moreMenu Accordion class="side-link settings" (click)="onClickSubmenu(moreMenu)">
          <img class="side-link__icon" loading="lazy" [src]="'/assets/img/new-categories/settings.png'" />
          <span class="side-link__label">
            {{ 'link.settings' | translate }}
          </span>
          <span class="side-link__chevron"></span>
        </span>

        <div class="submenu settings">
          @if (user.auth) {
            <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'profile', 'info']" (click)="sidebar.close()">
              <i class="icon-settings"></i>
              <span class="side-link__label">{{ 'link.my-acc' | translate }}</span>
            </a>
            <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'profile', 'documents']" (click)="sidebar.close()">
              <i class="icon-settings"></i>
              <span class="side-link__label">{{ 'link.doc' | translate }}</span>
            </a>
          }

          <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'blog']" (click)="sidebar.close()">
            <span class="side-link__label">{{ 'link.blog' | translate }}</span>
          </a>

          <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'tournaments']" (click)="sidebar.close()">
            <span class="side-link__label">
              {{ 'link.tournaments' | translate }}
            </span>
          </a>

          @if (lottery.showLotteryLink) {
            <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'lottery']" (click)="sidebar.close()">
              <span class="side-link__label">{{ 't.lottery' | translate }}</span>
            </a>
          }

          <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'banking']" (click)="sidebar.close()">
            <span class="side-link__label">{{ 'link.banking' | translate }}</span>
          </a>

          @if (user.auth) {
            <span class="side-link small-link logout" (click)="logout()">
              <span class="side-link__label">{{ 'link.logout' | translate }}</span>
            </span>
          }

          <hr class="separator" />

          <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'faq']" (click)="sidebar.close()">
            <span class="side-link__label">{{ 'link.faq' | translate }}</span>
          </a>

          <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'about']" (click)="sidebar.close()">
            <span class="side-link__label">{{ 'link.about' | translate }}</span>
          </a>


          <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'terms-and-conditions']" (click)="sidebar.close()">
            <span class="side-link__label">{{ 'link.t&c' | translate }}</span>
          </a>

          <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'bonus-terms']" (click)="sidebar.close()">
            <span class="side-link__label">{{ 'link.bonus-terms' | translate }}</span>
          </a>

          <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'privacy-policy']" (click)="sidebar.close()">
            <span class="side-link__label">{{ 'link.pp' | translate }}</span>
          </a>

          <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'cookie-policy']" (click)="sidebar.close()">
            <span class="side-link__label">{{ 'link.cookie-policy' | translate }}</span>
          </a>

          <a class="side-link small-link" [routerLink]="['/' + lang.currentRouteLanguage, 'responsible-gaming']" (click)="sidebar.close()">
            <span class="side-link__label">{{ 'link.res-game' | translate }}</span>
          </a>

          <a class="side-link small-link" target="_blank" href="https://www.samuraipartners.com" (click)="sidebar.close()">
            <span class="side-link__label">{{ 'link.affiliate' | translate }}</span>
          </a>
        </div>

        <div class="lang" #langRef (click)="onClickSubmenu(langRef)">
          <div #accordion="accordionDirective" Accordion class="lang__header">
            @let url = seo.domain() + (lang.current === ROOT_LANG ? '' : '/' + lang.current) + (currentPath() ? '/' + currentPath() : '');
            <span class="lang-item">
              <a class="flex items-center pointer-events-none" [href]="url">
                <img class="lang-item__icon" loading="lazy" [src]="'/assets/svg/lang/' + lang.current + '.svg'" />
                <span class="lang-item__label">{{ lang.current }}</span>
              </a>
            </span>

            <span class="side-link__chevron"></span>
          </div>

          <div class="lang__list">
            @for (lang of env.dataEnv()?.languageList; track $index) {
              @let urlItem = (lang.short === ROOT_LANG ? '' : '/' + lang.short) + (currentPath() ? '/' + currentPath() : '');
              <a class="lang-item" [href]="urlItem" (click)="changeLanguage(lang.short); $event.preventDefault()">
                <img class="lang-item__icon" loading="lazy" [src]="'/assets/svg/lang/' + lang.short + '.svg'" />
                <span class="lang-item__label">{{ lang.short }}</span>
              </a>
            }
          </div>
        </div>
      </div>
    </div>
    <!--END PRIMARY MENU-->
  </div>
</aside>
